import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = ({ children, loading }) => (loading ? <CircularProgress color="primary" size={50} /> : <>{children}</>);

export default Loader;
